<template>
  <div class="forceFillDialog">
    <el-dialog
      :visible.sync="forceFillMessage.show"
      width="600px"
      :modal='false'
      >
      <div class="content">
        <div>{{ $t("lang.forceFillOption") }}</div>
        <div class="select">
          <el-radio v-model="forceFillType" :label="1">{{ $t("lang.SqueezeToFit") }}</el-radio>
          <div class="describe">{{ $t("lang.automaticallyBeTrimmed") }}</div>
          <el-radio v-model="forceFillType" :label="2">{{ $t("lang.Ripple") }}</el-radio>
          <div class="describe">{{ $t("lang.shifted") }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="forceFillMessage.show = false">{{ $t("lang.cancel") }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t("lang.Confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    forceFillMessage: {
      type: Object,
      default: () => {
        return {
          show: false
          // fillType: 1
        }
      }
    }
  },
  data () {
    return {
      forceFillType: 1
    }
  },
  methods: {
    confirm () {
      this.$emit('forceFillSelect', this.forceFillType)
      this.forceFillMessage.show = false
    }
  }
}
</script>

<style lang='less' scoped>
 .forceFillDialog{
  ::v-deep .el-dialog{
      .el-dialog__header{
        height: 48px ;
        line-height: 48px;
      }
      .el-dialog__body{
        padding: 10px 20px;
        .content{
          text-align: left;
          .select{
            padding-top: 10px;
            .el-radio{
              .el-radio__label{
                color: #DBDBDB;
              }
            }
            .describe{
              padding-left: 25px;
              color: #606266;
            }
          }

        }
      }
      .el-dialog__footer{
        padding: 24px 0;
        button{
          padding: 10px 16px;
        }
      }
    }
  }
</style>
